export const isValidJSON = obj => {
  try {
    if (typeof obj === "object") {
      return true;
    }
    JSON.parse(obj);
    return true;
  } catch (e) {
    return false;
  }
};
